const apiRoutes = {
    login: "/api/admin/login",
    verifyOtp: "/api/auth/verify-otp",

    getLanguages: "/api/languages",
    getCategories: "/api/categories",
    getStates: "/api/states",

     DASHBOARD_SUMMARY: "/api/dashboard/summary",
     DASHBOARD_SUBSCRIPTIONS: "/api/dashboard/subscriptions",
     DASHBOARD_RECENT_BOOKS: "/api/dashboard/recent-books",
     DASHBOARD_EXPIRING_USERS: "/api/expiring-soon",
     DASHBOARD_EXPIRING_USERS_COUNT: "/api/expiring-soon",

    createBook: "/api/ebook/cover",
    getEbooks: "/api/ebook/covers",
    getUnpublishedEbooks: "api/ebook/unpublished/covers",
    getEBook: (id) => `/api/ebook/cover/${id}`,

    cloneBook: (id) => `/api/ebook-content/clone/${id}`,

    downloadEBook: (id) => `/api/ebook-content/download/${id}`,

    uploadAttachment:  "/api/ebook-attachments/upload",

    updateEBookCover: (id) => `/api/ebook/update/cover/${id}`,

    deletebook: (id) => `/api/ebook/cover/${id}`,

    getGenres: "/api/genres",
    saveBookContetnt: "/api/ebook-content",
    getAllAttachments: "/api/ebook-attachments/all-attachments",

    getBookContents: (id) => `/api/ebook-content/${id}`,
    createQuote: "/api/quotes",
    getAllQuotes: "/api/quotes/getall",

    createReader: "/api/user/reader/create",
    getAllReaders: "/api/user/readers/getall",
    createAdmin: "/api/admin/register",
    getAllAdmins: "/api/admin/getall",

    getSignedUrl: "/api/get-signed-url",
    updateUser: "/api/user/reader/update",
    deleteUser: (id) => `/api/user/reader/delete/${id}`,
    activateUser:(id) => `/api/user/reader/activate/${id}`
    
  };
  
  export default apiRoutes;
  